/* eslint-disable no-undef */
export const handleClickAndRedirect = (
  button_text,
  redirect_url,
  page_name,
) => {
  if (window.analytics) {
    window.analytics.track('Button Pressed', {
      button_text,
      page_or_screen_name: page_name,
    });
  }
  if (redirect_url) window.location.href = redirect_url;
};
